/**
 * @description 业务上报
 */

import { attaClick, attaExpose, attaPageView } from './report-atta';
import { initBeaconData, beacon } from './report-beacon';

// 业务数据上报
export default function doReport(param: { type: string; data: any }) {
  const { type, data } = param;
  switch (type) {
    case 'click':
      attaClick(data);
      break;
    case 'expose':
      attaExpose(data);
      break;
    case 'pageview':
      attaPageView(data);
      break;
    case 'update':
    case 'init':
      initBeaconData(data);
      break;
    default:
      beacon(data);
  }
}
